import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { InfoBox, InfoBoxProps } from '../../../../common/info-box'

const InfoBoxRowStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top: 2px solid ${({ theme }) => theme.colors.background.grey};
  padding: 30px 0;
  flex-grow: 2;
`

interface InfoBoxRowProps extends InfoBoxProps {
  className?: string
}

export const InfoBoxRow: FC<PropsWithChildren<InfoBoxRowProps>> = ({ children, className, ...infoBoxProps }) => {
  return (
    <InfoBoxRowStyled className={className}>
      <InfoBox {...infoBoxProps}>{children}</InfoBox>
    </InfoBoxRowStyled>
  )
}
